import { OptionItem } from 'models';

export const OPTIONS_DATA_TYPE = [
  {
    name: 'Just Once',
    value: 'just_once',
  },
  {
    name: 'Recurring',
    value: 'recurring',
  },
  {
    name: 'Concierge',
    value: 'concierge',
  },
];

export const DAY_OF_WEEK = [
  {
    name: 'Mon',
    value: 1,
    isChecked: false,
    nameData: 'MO',
  },
  {
    name: 'Tue',
    value: 2,
    isChecked: false,
    nameData: 'TU',
  },
  {
    name: 'Wed',
    value: 3,
    isChecked: false,
    nameData: 'WE',
  },
  {
    name: 'Thu',
    value: 4,
    isChecked: false,
    nameData: 'TH',
  },
  {
    name: 'Fri',
    value: 5,
    isChecked: false,
    nameData: 'FR',
  },
  {
    name: 'Sat',
    value: 6,
    isChecked: false,
    nameData: 'SA',
  },
  {
    name: 'Sun',
    value: 7,
    isChecked: false,
    nameData: 'SU',
  },
];

export enum TypeSR {
  just_once = 'just_once',
  recurring = 'recurring',
}

export interface IFormGenerateJob {
  parent?: {
    id: string;
    label: string;
  };
  children: {
    id: string;
    picture: string | null;
    age_range: number;
    full_name: string;
    is_checked: boolean;
    date_of_birth?: string;
  }[];
  type: string;
  days_of_week: any[];
  from_date: string;
  from_time: string;
  to_date: string;
  to_time: string;
  address?: OptionItem | null;
  sitters?: OptionItem | null;
  special_notes1: string;
  special_notes2: string;
  special_notes3: string;
  has_dog: boolean;
  has_cat: boolean;
  ac_sitter_rate: number;
}

export const defaultValuesGenerateJob: IFormGenerateJob = {
  parent: undefined,
  type: '',
  from_date: '',
  from_time: '',
  to_date: '',
  to_time: '',
  children: [],
  days_of_week: [],
  address: undefined,
  sitters: undefined,
  special_notes1: '',
  special_notes2: '',
  special_notes3: '',
  has_dog: false,
  has_cat: false,
  ac_sitter_rate: 0,
};
